import http from "./http-service"

export default class OppBalanceService {

  static getReserveById(branch, id) {
    return http.get(`opp-balances/reserves/${branch}/${id}`)
  }

  static getEntities(entity) {
    return http.get(`opp-balances/entities/${entity}`).then((response) => response.entities)
  }

  static searchReserves(data) {
    return http.post("opp-balances/search-reserves", data).then((response) => response.reserves)
  }

  static searchBalances(data) {
    return http.post("opp-balances/search-balances", data).then((response) => response.balances)
  }

  static interest(data) {
    return http.post("opp-balances/interest", data)
  }

  static reserve(data) {
    return http.post("opp-balances/reserve", data).then((response) => response.reserveId)
  }

  static cancel(branch, reserveId) {
    return http.post("opp-balances/cancel", { branch, reserveId })
  }
}

OppBalanceService.RESERVE_STATUS = {
  WAITING: "1",  
  CONFIRMED: "2",
  EXPIRED: "3",
  CANCELED: "4",
}